import { useQuery } from '@tanstack/react-query';
import V1InstanceApi from '@Apis/V1/instance';

/**
 * Custom hook to get general trial status
 *
 * @returns Query result with general trial status data and loading/error states
 */
export const useGeneralTrialStatus = () => {
  return useQuery<Boolean>({
    queryKey: ['generalTrialStatus'],
    queryFn: async () => {
      try {
        const response = await V1InstanceApi.getGeneralTrialStatus();
        return response.status === 'Activated';
      } catch (error: any) {
        const isExternalNotFound =
          error?.status === 404 &&
          error?.data?.errors?.[0]?.code === 'ExternalNotFound';

        if (isExternalNotFound) {
          // Return a special status to indicate no general trial found
          return false;
        }

        // Re-throw other errors
        throw error;
      }
    },
    // Cache for 5 minutes
    staleTime: 10 * 60 * 1000,
    // Retry once on failure
    retry: 1,
    // Don't refetch on window focus to avoid unnecessary API calls
    refetchOnWindowFocus: false,
  });
};
